
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/[tier]",
      function () {
        return require("private-next-pages/packages/[tier]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/[tier]"])
      });
    }
  